export const UNDO_SEQUENCE_DATA_EVENT = 'dnascript:sequence:undo';

export const resetSequenceData = () => {
  window.setTimeout(() => {
    document.dispatchEvent(new Event(UNDO_SEQUENCE_DATA_EVENT));
  }, 50);
};
